<script lang="ts">
</script>

<div>
  <h1>Combined Benefits</h1>

  <div class="text">
    <!--
      Use two separate parageaphs to insure that this section has enough
      height that it can actually be selected in the sidebar correctly. It's
      otherwise right at a boundary where the sliders are going unsticky and it
      causes weirdness with the sidebar.
    -->
    <p>
      So far we have only looked at each person's personal benefits based on
      their own earnings record.
    </p>
    <p>
      In some cases, recipients are eligible for additional benefits based on
      their spouse's earnings record.
    </p>
  </div>
</div>

<style>
  h1 {
    text-decoration: underline;
  }
  .text {
    margin: 0 0.5em;
  }
</style>
